<template>
    <div class="info-container" ref="infoContainer">
        <div class="info-icon" v-tooltip="tip">i</div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';

const props = defineProps({
    tip: {
        type: String,
        required: true
    }
});


</script>

<style scoped>
/* Container for the icon */
.info-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
}

/* Style for the "i" icon */
.info-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: gray;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    font-style: italic;
}

/* Tooltip styling */
.tooltip {
    position: fixed;
    background-color: #333;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 4px 8px;
    white-space: normal;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.2s;
    transform: translateX(-50%);
    max-width: 200px;
    word-wrap: break-word;
}

/* Tooltip visibility */
.tooltip[style*="top"] {
    opacity: 1;
}
</style>
